import { PaymentApibuild } from '@utils/api-url-builder';

const API_RESOURCE_SEGMENT_URL = 'api/ServerInfo';

export const URLS = {
  GET_SERVER_INFO: PaymentApibuild([API_RESOURCE_SEGMENT_URL], 'get-server-info')
};
